export default __webpack_public_path__ + "static/media/spotify.dffc4909.png";